import React, { useEffect, useState, forwardRef, useImperativeHandle } from "react";
import { Input } from "sr/helpers";
import { useValidationErrorHandle } from "sr/helpers/functions/validationErrorHandle";

type Props = {
  data: { experience?: string };
  HandleDataProps: (payload: { experience: string }) => void;
};

const BidExperienceChange = forwardRef(({ data, HandleDataProps }: Props, ref) => {
  const [experience, setExperience] = useState("");
  const [errorId, setErrorId] = useState<string>("");
  const validationErrorHandle = useValidationErrorHandle();

  useEffect(() => {
    setExperience(data?.experience || "");
  }, [data?.experience]);

  useImperativeHandle(ref, () => ({
    validateData: () => {
      if (!experience.trim()) { setErrorId('INPUT.VALIDATION.BID.EXPERIENCE'); return false; }
      setErrorId('');
      return true;
    },
    submitForm: () => {
      const newData = { experience: experience.trim() };
      HandleDataProps(newData);
      return newData;
    },
  }));

  return (
    <div>
      <p className="pt-4 text-base">Relevant Experience</p>
      <Input
        name="experience"
        value={experience}
        onChange={(e: any) => setExperience(e.target.value)}
        placeholder="e.g. 5+ years in Renovation"
        error={errorId}
      />
    </div>
  );
});

export default BidExperienceChange;
